import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { MapRemixButton as Button } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'

import { openMapRemixDrawer } from '~map-preview/states/ui'

let once = false
const MapRemixButton = (props) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { authenticated } = useAuth()
  const { gotoSignInPage } = useFederatedAuth()

  const handleClick = () => {
    dispatch(openMapRemixDrawer())
  }

  const handleSignInClick = () => {
    gotoSignInPage({
      redirect: router.asPath + '?remix=true'
    })
  }

  const clearQuery = () => {
    delete router.query.copy
    router.replace({ query: router.query }, undefined, {
      shallow: true
    })
  }

  useEffect(() => {
    const autoRemix = async () => {
      if (router.query?.remix !== 'true') return
      if (once) return

      dispatch(openMapRemixDrawer())
      clearQuery()
      once = true
    }

    autoRemix()
  }, [])

  return (
    <Button
      authenticated={authenticated}
      onClick={handleClick}
      onSignInClick={handleSignInClick}
    />
  )
}

export { MapRemixButton }
